import { useState, useCallback } from 'react';

export const usePopoverState = () => {
  const [buttonRef, setButtonRef] = useState<Element | null>(null);

  const buttonHandle = useCallback(({ currentTarget }: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setButtonRef(currentTarget);
  }, [setButtonRef]);

  const resetButtonRef = useCallback(() => {
    setButtonRef(null);
  }, [setButtonRef]);

  const showPopover = !!buttonRef;

  return [buttonRef, showPopover, buttonHandle, resetButtonRef] as const;
};
